<canvas #canvasRef class="signature-canvas"></canvas>
